import { z } from "zod";

export const stationSelectionSchema = z.lazy(() =>
  z.object({
    stationIds: z.array(z.number()),
  })
);
export type StationSelectionForm = z.infer<typeof stationSelectionSchema>;
